import React from "react";
import CircularGraphWithIcon from "../Graph/CircularGraph";
import { DateTime } from "luxon";

export const DashboardtopContainer = ({
  onboarded,
  engaging,
  monthlyengagingusers,
  monthlyusers,
  monthValue,
}: any) => {
  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM");
  }

  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;

  return (
    <div>
      <div
        style={{
          // flex: 1,
          backgroundColor: "#f0efe9",
          marginRight: "20px",
          borderRadius: "8px",
        }}
      >
        {!monthValue &&<div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "40px 20px 25px 20px",
            alignItems: "center",
            // padding:"30px "
          }}
        >
          <div>{access_code? "Employees":"Users"} Onboarded</div>
          <div style={{ fontSize: "24px", color: "#e86943" }}>{onboarded}</div>
        </div>}
        {monthValue && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "40px 20px 25px 20px",
              alignItems: "center",
              // padding:"30px "
            }}
          >
            <div>{access_code? "Employees":"Users"} Onboarded {getMonthName(monthValue)} Month</div>
            <div style={{ fontSize: "24px", color: "#e86943" }}>
              {monthlyusers}
            </div>
          </div>
        )}
       {!monthValue && <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 20px 50px 20px",
            alignItems: "center",
            // paddingBottom:"30px"
          }}
        >
          <div>
            {" "}
            <div>{access_code? "Employees":"Users"} Engaging</div>
            <div
              style={{
                color: "#b0aeb1",
                fontSize: "12px",
                // borderBottom: "1px solid white",
              }}
            >
              All time
            </div>
          </div>
          <div style={{ fontSize: "24px", color: "#4fb8f3" }}>{engaging}</div>
        </div>}

        {monthValue && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px 50px 20px",
              alignItems: "center",
              // paddingBottom:"30px"
            }}
          >
            <div>
              {" "}
              <div>{access_code? "Employees":"Users"} Engaging {getMonthName(monthValue)}</div>
            </div>
            <div style={{ fontSize: "24px", color: "#4fb8f3" }}>
              {monthlyengagingusers}
            </div>
          </div>
        )}

        <div style={{ padding: "0 20px 60px 20px" }}>
          <CircularGraphWithIcon average={engaging} total={onboarded} />
        </div>
      </div>
    </div>
  );
};
